import { Component, Inject } from '@angular/core'
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms'
import {
  MAT_DIALOG_DATA,
  MatDialogActions, MatDialogClose,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle
} from '@angular/material/dialog'
import { type VehicleDTOExtended } from '../../../../services/vehicles.service'
import { type DealerDTO } from '../../../../services/dealers.service'
import { HubChildTranslateModule } from '@inside-hub-app/hub-translate'
import { MatRadioButton, MatRadioGroup } from '@angular/material/radio'
import { SharedTranslatePipe } from '@inside-hub-app/customer-portal-shared'
import { MatIcon } from '@angular/material/icon'
import { NgClass } from '@angular/common'

interface AppointmentsPopupChooseStepComponentData {
  vehicle: VehicleDTOExtended
}
@Component({
  selector: 'customer-portal-app-appointments-popup-choose-step',
  standalone: true,
  imports: [
    HubChildTranslateModule,
    MatDialogTitle,
    MatDialogContent,
    MatRadioGroup,
    MatRadioButton,
    MatDialogActions,
    SharedTranslatePipe,
    MatIcon,
    MatDialogClose,
    ReactiveFormsModule,
    NgClass
  ],
  templateUrl: './appointments-popup-choose-step.component.html'
})
export class AppointmentsPopupChooseStepComponent {
  public form = new FormGroup({
    type: new FormControl<'CPT' | 'serviceManager' | null>(null)
  })

  serviceDealer: DealerDTO

  constructor (
    @Inject(MAT_DIALOG_DATA)
    public data: AppointmentsPopupChooseStepComponentData,
    private readonly dialogRef: MatDialogRef<AppointmentsPopupChooseStepComponent>
  ) {
    this.serviceDealer = data?.vehicle?.dealers?.serviceDealer
  }

  select (): void {
    this.dialogRef.close(this.form.get('type')?.value)
  }
}
